import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import {
    BasemapLayerType,
    BASEMAPS_CATALOG,
    TileSourceTypeEnum,
} from '@connect-services/client/services/basemap.service';
import { RessourcesModule } from '@ressources/client/ressources.module';

type BasemapLabelNamespace = 'basemap' | 'basemapKey';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-basemap-tile',
    styleUrl: './basemap-tile.component.scss',
    templateUrl: './basemap-tile.component.html',
})
export class BasemapTileComponent {
    public readonly isBackground = computed<boolean>(
        () => BASEMAPS_CATALOG[this.type()].layerType === BasemapLayerType.BACKGROUND,
    );
    public readonly labelKeyPrefix = input<BasemapLabelNamespace>('basemapKey');
    public readonly opacity = input<number>(1);
    public readonly opacityChange = output<number>();
    public readonly opacityReadOnly = input<boolean>(false);
    public readonly percentage = computed<string>(() => {
        const value = Number.isFinite(this.opacity()) ? this.opacity() : 1;
        const clamped = Math.max(0, Math.min(1, value));

        return `${Math.round(clamped * 100)}%`;
    });
    public readonly pressed = output<void>();
    public readonly selected = input<boolean>(false);
    public readonly showHoverUpdate = input<boolean>(false);
    public readonly showOpacity = input<boolean>(true);
    public readonly showTrash = input<boolean>(false);
    public readonly trash = output<void>();
    public readonly type = input.required<TileSourceTypeEnum>();

    protected readonly BASEMAPS_CATALOG = BASEMAPS_CATALOG;

    public handleOpacityInput(event: Event): void {
        if (this.opacityReadOnly() || !this.showOpacity()) {
            return;
        }

        const target = event.target as HTMLInputElement | null;
        const raw = target?.value ?? '';
        const parsed = Number(String(raw).replace(/[^\d.]/g, ''));

        const number = Number.isFinite(parsed) ? Math.max(0, Math.min(100, parsed)) : 50;
        this.opacityChange.emit(number / 100);
    }
}
